




import {Component, Prop, Vue} from "vue-property-decorator";
import {PartnerType} from "@/enums/type";

@Component({
    name: "PartnerTypeLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly type!: number;

    PartnerType = PartnerType;
}
